import { createSelector } from 'reselect'

import { selectAssortmentState } from './selectAssortmentState'

export const selectAssortmentSettingsCategories = createSelector(
  [selectAssortmentState],
  (state) => {
    return state.categories.originalData
  }
)
